<template>
   <svg viewBox="0 0 6 8" fill="currentColor" aria-hidden="true" focusable="false">
      <path d="M6 4.125L-3.26266e-07 7.5891L-2.34249e-08 0.660898L6 4.125Z" />
   </svg>
</template>
